import { render, staticRenderFns } from "./VideoEditDialog.vue?vue&type=template&id=b197bc3e&"
import script from "./VideoEditDialog.vue?vue&type=script&lang=js&"
export * from "./VideoEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports